import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";

export const useGetV4SearchQueryReportOptions = () => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: [{ entity: "V4SearchQueryPerformanceValues", marketPlace }],
    queryFn: async () =>
      await apiClient.getV4SearchQueryReportOptions({
        queries: {
          marketplace: marketPlace,
        },
      }),
    placeholderData: keepPreviousData,
  });
};
